/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import {
  getBulkRowGuid,
  getBulkRowTuples,
  hasSameBulkRowTuples,
} from "../realtime/bulkUploadProjection";

const defaultState = {
  bulkUploadList: [],
  selectedBulkImageList: [],
  uploadableList: [],
  saveBulkImgRes: "",
  reportCountAlert: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    //   store
    case "CREATE_BULK_IMAGE_LIST": {
      return {
        ...state,
        bulkUploadList: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "SELECTED_BULK_IMAGE_LIST": {
      return {
        ...state,
        selectedBulkImageList: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "ADD_BULK_IMG_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "ADD_BULK_IMG_FULFILLED": {
      return {
        ...state,
        saveBulkImgRes: action.payload,
        bulkUploadList: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "ADD_BULK_IMG_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    }
    case "GET_BULK_IMG_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }
    case "GET_BULK_IMG_FULFILLED": {
      const bulkUploadList = action.payload.data;
      const currentRowsByGuid = new Map(
        bulkUploadList
          .map((row) => [getBulkRowGuid(row), row])
          .filter(([guid]) => guid)
      );
      const selectedBulkImageList = state.selectedBulkImageList
        .map((row) => currentRowsByGuid.get(getBulkRowGuid(row)))
        .filter(Boolean);

      return {
        ...state,
        bulkUploadList,
        selectedBulkImageList,
        uploadableList: bulkUploadList,
        loading: false,
        errors: {},
      };
    }
    case "GET_BULK_IMG_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    }
    //store
    case "UPDATE_BULK_IMAGE_LIST_BY_ID": {
      const payloadTuples = getBulkRowTuples(action.payload);
      const payloadGuid = getBulkRowGuid(action.payload);
      const matches = state.bulkUploadList
        .map((element, index) => {
          const elementTuples = getBulkRowTuples(element);
          const exactTupleMatch = hasSameBulkRowTuples(
            element,
            action.payload
          );
          const scalarGuidMatch =
            payloadGuid &&
            elementTuples.length === 0 &&
            getBulkRowGuid(element) === payloadGuid;
          return exactTupleMatch || scalarGuidMatch ? index : -1;
        })
        .filter((index) => index >= 0);
      if (matches.length !== 1) return state;
      const [matchedIndex] = matches;
      const previousRow = state.bulkUploadList[matchedIndex];

      const bulkUploadList = state.bulkUploadList.map((element, index) =>
        index === matchedIndex ? action.payload : element
      );
      const selectedBulkImageList = state.selectedBulkImageList.map(
        (selected) =>
          selected === previousRow ||
          hasSameBulkRowTuples(selected, previousRow) ||
          (payloadTuples.length === 0 &&
            getBulkRowTuples(selected).length === 0 &&
            getBulkRowGuid(selected) === payloadGuid)
            ? action.payload
            : selected
      );

      return {
        ...state,
        bulkUploadList,
        selectedBulkImageList,
        loading: false,
        errors: {},
      };
    }
    case "REMOVE_BULK_IMAGE_BY_ID": {
      return {
        ...state,
        bulkUploadList: state.bulkUploadList.filter(
          (image) => image.guid !== action.payload
        ),
        loading: false,
        errors: {},
      };
    }
    case "TRIGGER_BULK_REPORT_COUNT_ALERT": {
      return {
        ...state,
        reportCountAlert: action.payload,
      };
    }

    // View Images start author:Sai
    case "SWAP_BULK_UPLOAD_IMAGES_FULFILLED": {
      return {
        ...state,
        bulkUploadList: action.payload,
      };
    }
    case "DELETE_IMAGES_FROM_IDB_AND_STORE_FULFILLED": {
      return {
        ...state,
        selectedBulkImageList: [],
        bulkUploadList: action.payload.data,
        loading: false,
      };
    }
    // View Images End

    default:
      return state;
  }
};
